import { theme } from '@fiverr-private/theme';
import useBreakpoints from '../useBreakpoints';

type Breakpoint = keyof typeof theme.numericBreakpoints;

/**
 * Returns the current breakpoint on CSR according to `@fiverr-private/theme` breakpoints definition.
 * Returns 'default' during SSR and for screens smaller than the sm breakpoint.
 */
const useBreakpoint = (): Breakpoint | 'default' | undefined => {
    const { sm, md, lg, xl, xxl, default: isDefault } = useBreakpoints();

    if (!isDefault) {
        return undefined;
    }

    if (xxl) {
        return 'xxl';
    }

    if (xl) {
        return 'xl';
    }

    if (lg) {
        return 'lg';
    }

    if (md) {
        return 'md';
    }

    if (sm) {
        return 'sm';
    }

    return 'default';
};

export default useBreakpoint;
